import { lazy } from "react";

export const SellerHome = lazy(
  () => import("./SellerHome/SellerHome"),
);

export const SellerProducts = lazy(
  () => import("./Products/Products"),
);

export const SellerSingleProducts = lazy(
  () =>
    import("./Products/SellerSingleProducts/SellerSingleProducts"),
);

export const CreateProduct = lazy(
  () => import("./CreateProduct/CreateProduct"),
);

export const EditProduct = lazy(
  () => import("./EditProduct/EditProduct"),
);

export const EditProductVariant = lazy(
  () => import("./EditProduct/EditProductVariant"),
);

export const SellerOrders = lazy(
  () => import("./SellerOrders/SellerOrders"),
);

export const SellerStore = lazy(
  () => import("./SellerStore/SellerStore"),
);

export const BankingFinance = lazy(
  () => import("./BankingFinance/BankingFinance"),
);

export const SellerQuoteRequest = lazy(
  () => import("./SellerQuoteRequest/SellerQuoteRequest"),
);

export const PLPSellerMainPage = lazy(
  () => import("./PLPSeller/PLPSellerMainPage/PLPSellerMainPage"),
);

export const PLPSeller = lazy(() => import("./PLPSeller/PLPSeller"));

export const PLPSellerApplicationForm = lazy(
  () => import("./PLPSeller/PLPApplication/PLPSellerApplicationForm"),
);

export const SellerNotification = lazy(
  () => import("./SellerNotification/SellerNotification"),
);

//
export const SellerOrdersDetails = lazy(
  () => import("./SellerOrderDetails/SellerOrdersDetails"),
);

export const SellerOrderTrackingPage = lazy(
  () => import("./SellerOrderTrackingPage/SellerOrderTrackingPage"),
);

export const SellerQuoteDetails = lazy(
  () => import("./SellerQuoteDetails/SellerQuoteDetails"),
);

export const SupportPage = lazy(
  () => import("./Support/SupportPage"),
);

export const SellerSettings = lazy(
  () => import("./SellerSettings/SellerSettings"),
);

export const SellerSecurity = lazy(
  () => import("./SellerSettings/SellerSecurity/SellerSecurity"),
);

export const SellerPickupLocations = lazy(
  () =>
    import("./SellerSettings/SellerPickupLocations/SellerPickupLocations"),
);

export const SettingsMainPage = lazy(
  () => import("./SellerSettings/SettingsMainPage/SettingsMainPage"),
);

export const SellerProfile = lazy(
  () => import("./SellerSettings/SellerProfile/SellerProfile"),
);

export const BusinessProfile = lazy(
  () => import("./SellerSettings/BusinessProfile/BusinessProfile"),
);

export const BusinessBasicInformation = lazy(
  () =>
    import("./SellerSettings/BusinessProfile/BusinessProfileUpdate/BusinessBasicInformation/BusinessBasicInformation"),
);

export const CACDocuments = lazy(
  () =>
    import("./SellerSettings/BusinessProfile/BusinessProfileUpdate/CACDocuments/CACDocuments"),
);

export const AddNewProduct = lazy(
  () => import("./Products/AddProduct/AddNewProduct"),
);

export const ProductListSetup = lazy(
  () => import("./Products/ProductListSetup"),
);
